import PropTypes from 'prop-types';
import React, { memo } from 'react';
import './action-items-cell.scss';
import clsx from 'clsx';
import { MoreVertical } from 'react-feather';
import ContextMenu from '../../../context-menu';
import Icon from '../../../icon';
import Button, { ButtonTypes } from '../../../button';
import Tooltip, { TooltipPlacements } from '../../../tooltip';

const ActionItemsCell = ({
  actionItems, maxActions, onAction, disabledActions, invisibleActions, disabled, ctaButtons,
}) => {
  let menuItems = [];

  if (actionItems.length > maxActions) {
    menuItems = actionItems.filter(
      (item) => !invisibleActions.includes(item.id),
    ).slice(maxActions);
  }

  const directItems = actionItems.filter(
    (item) => !invisibleActions.includes(item.id),
  ).slice(0, maxActions);

  const handleItemClicked = (id) => {
    onAction(id);
  };

  const mapActions = (items, disabledItems) => {
    const ids = new Set(disabledItems);
    if (disabled) {
      return [];
    }
    const newState = items.map((el) => {
      if (!ids.has(el.id)) return el;
      return {
        ...el,
        disabled: true,
      };
    });
    return newState;
  };

  const getKebabMenu = () => {
    if (menuItems.length) {
      return (
        <ContextMenu items={mapActions(menuItems, disabledActions)} onSelect={handleItemClicked}>
          <div className={clsx('tbl-row-action-item', 'kebab', disabled && 'trai-disabled')}>
            <Button
              type={ButtonTypes.SECONDARY}
              renderIcon={({ size, color }) => (
                <Icon
                  size={size}
                  color={color}
                  icon={MoreVertical}
                />
              )}
              borderLess
              disabled={disabled}
            />
          </div>
        </ContextMenu>
      );
    }
    return null;
  };

  const getActionItemButton = ({
    id, renderIcon, description, buttonClassName,
  }) => {
    const isDisabled = disabledActions.some((action) => action === id);

    if (!isDisabled && description) {
      return (
        <Tooltip description={description} placement={TooltipPlacements.BOTTOM}>
          <Button
            borderLess
            renderIcon={renderIcon}
            disabled={isDisabled}
            type={ButtonTypes.SECONDARY}
            className={buttonClassName}
            onClick={() => handleItemClicked(id)}
          />
        </Tooltip>
      );
    }
    return (
      <Button
        borderLess
        renderIcon={renderIcon}
        disabled={isDisabled}
        type={ButtonTypes.SECONDARY}
        onClick={() => handleItemClicked(id)}
      />
    );
  };

  const getActionItem = (buttonData) => (
    <div className="tbl-row-action-item" key={buttonData.id}>
      {getActionItemButton(buttonData)}
    </div>
  );

  const getCTAButton = ({
    id, label, type, className, size, renderIcon, borderLess,
  }) => (
    <Button
      id={id}
      key={id}
      type={type}
      size={size}
      renderIcon={renderIcon}
      label={label}
      onClick={() => onAction(id)}
      className={className}
      borderLess={borderLess}
    />
  );

  const getCTAButtons = () => ctaButtons.map((ctaData) => (
    ctaData.label || ctaData.disabled ? getCTAButton(ctaData) : (
      <Tooltip
        key={ctaData.id}
        placement={TooltipPlacements.BOTTOM}
        description={ctaData.description}
      >
        {getCTAButton(ctaData)}
      </Tooltip>
    )
  ));

  return actionItems.length || ctaButtons.length > 0 ? (
    <td className="tbl-row-action-items-cont tbl-td">
      <div className="trai-wrapper">
        {ctaButtons.length > 0 && getCTAButtons()}
        {directItems.map((item) => getActionItem(item))}
        {getKebabMenu()}
      </div>
    </td>
  ) : null;
};

ActionItemsCell.defaultProps = {
  onAction: () => { },
  disabledActions: [],
  invisibleActions: [],
  disabled: false,
  ctaButtons: [],
};

ActionItemsCell.propTypes = {
  maxActions: PropTypes.number.isRequired,
  actionItems: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onAction: PropTypes.func,
  disabledActions: PropTypes.arrayOf(PropTypes.string),
  invisibleActions: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  ctaButtons: PropTypes.arrayOf(PropTypes.shape({})),
};

export default memo(ActionItemsCell);
